export default __webpack_public_path__ + "static/media/digiTimeout@2x.27468beb.png";